export const LAYOUTS = {
  ICON: "icon",
  INPUT: "input",
  EXPANDED: "expanded",
  SIDEBAR: "sidebar",
  FULL: "full",
};
export const VALID_LAYOUTS = Object.values(LAYOUTS);
